export class DeserializableMap {
    constructor(valueConstructor, getIDFunction) {
        this.values = new Map();
        this.valueConstructor = valueConstructor;
        this.getIDFunction = getIDFunction;
    }
    deserialize(input) {
        for (const jsonValueType of input) {
            const value = new this.valueConstructor().deserialize(jsonValueType);
            this.values.set(this.getIDFunction(value), value);
        }
        return this;
    }
    get(id) {
        const value = this.values.get(id);
        if (!value) {
            throw new Error("Unknown value: " + id);
        }
        return value;
    }
}
